var map = {
	"./1-ikava.jpg": "dd75",
	"./10-tyhjyys.jpg": "b410",
	"./11-uupunut-sydan.jpg": "d798",
	"./12-hehku.jpg": "906c",
	"./13-tyyneys.jpg": "f790",
	"./14-pilvilinna.jpg": "2498",
	"./15-kastehelmi.jpg": "ce83",
	"./16-meren-aalloissa.jpg": "98a2",
	"./17-erottamattomat.jpg": "50b6",
	"./18-elaman-tuli.jpg": "a824",
	"./19-ikuisuuteen.jpg": "2bd6",
	"./2-valon-luo.jpg": "2910",
	"./20-elon-illassa.jpg": "b0dd",
	"./3-kaiho.jpg": "a127",
	"./4-viimeinen-lento.jpg": "ac45",
	"./5-yon-helmi.jpg": "02b9",
	"./6-sateenkaaren-taa.jpg": "58b6",
	"./7-muistolle.jpg": "f190",
	"./8-kaksin.jpg": "6822",
	"./9-siivilla.jpg": "7d20"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";